/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type CreateSignedChatAttachmentURLResult = {
  /**
   * When the signed URL expires
   */
  expiresAt: Date;
  /**
   * The signed URL to access the chat attachment
   */
  url: string;
};

/** @internal */
export const CreateSignedChatAttachmentURLResult$inboundSchema: z.ZodMiniType<
  CreateSignedChatAttachmentURLResult,
  unknown
> = z.pipe(
  z.object({
    expires_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    url: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "expires_at": "expiresAt",
    });
  }),
);

export function createSignedChatAttachmentURLResultFromJSON(
  jsonString: string,
): SafeParseResult<CreateSignedChatAttachmentURLResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      CreateSignedChatAttachmentURLResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateSignedChatAttachmentURLResult' from JSON`,
  );
}
